import React from 'react';
import { Auth } from 'aws-amplify'

import Logo from '../../Images/Logo.png'
import LogoSmall from '../../Images/LogoSmall.png'
import { withRouter, Link } from 'react-router-dom'
import { Layout, Menu, Icon, PageHeader, Badge, Popover, Button } from 'antd'
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

const { Header, Sider, Content, Footer } = Layout;

class Base extends React.Component {

  constructor(props){
    super(props);
    this.state={
      menuState:false,
    }
  }

  signout = () => {
    Auth.signOut({ global: true })
      .then(data => {
        this.props.Logout()
        this.props.history.push("/login")
      })
      .catch(err=>{
        console.log(err)
        this.props.Logout()
        this.props.history.push("/login")
      })
  }


  async onMenuClick(e) {
    if (e.key === "logout") {
      this.signout()
    }
    else {
      this.props.history.push("/" + e.key)
    }
  }

  itemRender(route, params, routes, paths) {
    const last = routes.indexOf(route) === routes.length - 1;
    return last ? (
      <span>{route.breadcrumbName}</span>
    ) : (
        <Link to={route.path}>{route.breadcrumbName}</Link>
      );
  }

  render() {

    if (this.props.login.user === null) return null

    let bloqueoPago=(this.props.login.user_data.estado_pago ==='PAGO_EN_PROCESO'|| this.props.login.user_data.estado_pago === 'VENCIDO' || this.props.login.user_data.estado_pago === 'INACTIVO' || this.props.login.user_data.estado_usuario === 'BAJA' || this.props.login.user_data.estado_usuario==='BAJA_PROGRAMADA' || this.props.login.user_data.estado_usuario === 'BLOQUEADO')?true:false
    let bloqueoIncompleto =( this.props.login.user_data.estado_usuario ==='INCOMPLETO'|| this.props.login.user_data.estado_usuario === 'PENDIENTE_REVISION' || this.props.login.user_data.estado_usuario === 'INACTIVO')?true:false

    const title = this.props.login.user.attributes.email;
    const content = (
      <div>
        <Link to='/micuenta'>Mi cuenta</Link>

        <p></p>
        <a href="#/" onClick={this.signout}>
          <Icon
            type={'logout'}
          /> Salir
        </a>
      </div>
    );

    return (
      <Layout style={{ minHeight: "100vh" }}>
        <Sider
          collapsedWidth={0}
          trigger={null}
          breakpoint={"md"}
           onBreakpoint={(broken) => {
             if (broken !== this.state.menuState) {
               this.setState({menuState:!this.state.menuState})
             }
           }}
          collapsible
          collapsed={this.state.menuState}
          style={{ backgroundColor: "#49ECAD" }}
        >
          <center><Link to='/'><img alt="logo" src={!this.state.menuState ? Logo : LogoSmall} className="logo" style={{ height: "60px", marginTop: "15px", marginBottom: "15px" }} /></Link></center>
          <Menu theme="dark" style={{ backgroundColor: "#1C1B1B"}} mode="inline" defaultSelectedKeys={[this.props.selected]} onClick={(e) => this.onMenuClick(e)} >
            <Menu.Item key="home">
              <Icon type="home" />
              <span>Inicio</span>
            </Menu.Item>
            <Menu.Item key="facturar" disabled={bloqueoPago||bloqueoIncompleto}>
              <Icon type="file-add" />
              <span>Facturar</span>
            </Menu.Item>
            <Menu.Item key="emitir-constancia" disabled={bloqueoPago||bloqueoIncompleto} onClick ={()=>window.open('https://seti.afip.gob.ar/padron-puc-constancia-internet/ConsultaConstanciaAction.do','_blank')}>
              <Icon type="idcard" />
              <span>Emitir constancia</span>
          </Menu.Item>
            <Menu.Item key="facturas-emitidas" disabled={bloqueoPago||bloqueoIncompleto} >
              <Icon type="solution" />
              <span>Facturas emitidas</span>
            </Menu.Item>
            <Menu.Item key="impuestos" disabled={bloqueoPago||bloqueoIncompleto}>
              <Icon type="folder-open" />
              <span>Mis impuestos</span>
            </Menu.Item>
            <Menu.Item key="pago-servicios" disabled={bloqueoIncompleto||bloqueoPago}>
              <Icon type="dollar" />
              <span>Pagos</span>
            </Menu.Item>
            <Menu.Item key="mejorar-plan">
              <Icon type="rise" />
              <span>Mi Plan</span>
            </Menu.Item>
            <Menu.Item key="logout">
              <Icon type="logout" />
              <span>Cerrar sesión</span>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
        <Header style={{ background: 'linear-gradient(to right, #353FDF, #49ECAD)', padding: 0 }}>
          {/* <Header style={{ background: 'linear-gradient(to right, #353FDF, #49ECAD)', padding: 0 }}> */}
            <Icon
              className="trigger"
              type={this.state.menuState ? 'menu-unfold' : 'menu-fold'}
              onClick={()=>this.setState({menuState:!this.state.menuState})}
              style={{
                color: "white",
                fontSize: "18px",
                lineHeight: "64px",
                padding: "0 24px",
                cursor: "pointer",
                transition: "color 0.3s",
              }}
            />
            <span style={{ float: "right", padding: "0 24px" }}>
              {
                this.props.login.admin &&
                <Link to="/admin" >
                  <Button type="default" icon="user-add" size={'small'} style={{ marginRight: "10px", fontWeight: 600, fontSize:'18'}}>
                    Admin Panel
                    </Button>
                </Link>
              }
              {
                this.props.login.adminLite &&
                <Link to="/admin-lite" >
                  <Button type="default" icon="user-add" size={'small'} style={{ marginRight: "10px", fontWeight: 600, fontSize:'18'}}>
                    AdminLite Panel
                  </Button>
                </Link>
              }
              <Popover
                placement="bottomRight"
                title={title}
                content={content}
                trigger="click"
              >
                <Badge dot >
                  <Button
                    icon="user"
                    shape="circle"
                  />
                </Badge>
              </Popover>
            </span>
          </Header>
          <Content
            style={{
              background: '#fff'
            }}
          >
            <PageHeader
              title={this.props.title}
              breadcrumb={{
                routes: this.props.routes,
                separator: ">",
                itemRender: this.itemRender
              }}
            >
              {this.props.children}
            </PageHeader>
          </Content>
          <Footer style={{ textAlign: 'center', padding: 15 }}>©2021 Liqui | All rights reserved.</Footer>
        </Layout>
      </Layout>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Base));
